module.exports = __webpack_public_path__ + "img/b8d0ea2.jpg";